import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/FactureAchat/';

export async function generationCharge(params) {
  const response = await HTTP.post(URL_BASE + 'GenerationChargeAsync', params);
  return response;
}

export async function suppressionCharge(id, avecEssaiSuppressionCharge) {
  const response = await HTTP.post(URL_BASE + 'SuppressionChargeAsync', { id: id }, {
    params: {
      avecEssaiSuppressionCharge,
    },
  });
  return response;
}

export async function generationPaiement(params) {
  const response = await HTTP.post(URL_BASE + 'GenerationPaiementAsync', params);
  return response;
}

export async function factureGeneration(params) {
  const response = await HTTP.post(URL_BASE + 'PFactureGenerationAsync', params);
  return response;
}

export async function generationPaiementUnitaire(params) {
  const response = await HTTP.post(URL_BASE + 'GenerationPaiementUnitaireAsync', params);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id } });
  return response;
}

export async function annulerFacturationCommandes(input) {
  const response = await HTTP.post(URL_BASE + 'AnnulerFacturationCommandesAsync', input);
  return response;
}

export async function annulerAllFacturationCommandes(input) {
  const response = await HTTP.post(URL_BASE + 'AnnulerAllFacturationCommandesAsync', input);
  return response;
}

export async function brouillon2Facture(input) {
  const response = await HTTP.post(URL_BASE + 'Brouillon2FactureAsync', input);
  return response;
}

export async function brouillon2FactureAll(ids) {
  const response = await HTTP.post(URL_BASE + 'Brouillon2FactureAllAsync', ids);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}
export async function avoirTotal(input) {
  const response = await HTTP.post(URL_BASE + 'AvoirTotalAsync', input);
  return response;
}

export async function create(facture) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', facture);
  return response;
}

export async function update(facture) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', facture);
  return response;
}
